export default "__VITE_ASSET__BDzpq7Ls__"